import React, { Component } from 'react';
import { connect } from "react-redux";
import { cloneDeep, debounce, filter, isEmpty, isNull } from "lodash";
import * as static_list_actions from "../../store/static_list/actions";
import disease_api from "../../api/disease-api";

import QueryToolbar from './query-toolbar'
import ResultFilter from './result-filter';
import TableFooter from '../tables/table-footer';
import ModalDeletePatient from '../modal-delete-patient';
import ModalConfirmReportDelete from '../modal-confirm-report-delete';
import ActivityIndicator from '../../components/activity-indicator'
import family_api from "../../api/family-api";
import genetic_testing_api from "../../api/genetic-testing-api"
import ModalSaveReport from "./modal-save-report"
import ModalOverwriteReport from '../modal-overwrite-report';
import userAccountApi from '../../api/user-account-api';

import { resetFamilyRedux } from "../../helpers/helper-family-tree";
import helpers from "../../helpers/index";
import { radix_bases } from '../../helpers/helper-number-bases';
import route_helper from "../../route-helper";
import * as helper_search from '../../helpers/helper-search'
import json_columns from './columns.json';
import moment from 'moment';
import qs from 'qs';
import jsPDF from 'jspdf';
import ErrorSummary from '../../components/error-summary'
import "jspdf/dist/polyfills.es.js";
import 'jspdf-autotable'
import Select from 'react-select'
import { createUUID } from '../react-flow-pedigree/utils';

import OutsideAlerter from './OutsideAlerter';
import AdvancedFilters from './advanced-filters'

import $ from 'jquery'

import { buildQueryPayload } from './query-utils'

function parseToInt(val) {
  return parseInt(val, radix_bases.base10);
}

class ResultList extends Component {

  constructor(props) {
    super(props);
    this.queryToolbarRef = React.createRef();
    this.diseaseFilterRef = React.createRef();
    this.geneTestingFilterRef = React.createRef();
    this.referralFilterRef = React.createRef();
    this.moreFilterRef = React.createRef();
    this.resultFilterRef = React.createRef();
    this.state = {
      loading: false,
      probands: [],
      errorMessages: [],
      showSaveReport: false,
      showOverwriteReport: [false, ''],
      showDeletePatientModal: false,
      showDeleteReportModal: [false, ''],
      currentPatient: null,
      columns: [],
      allColumns: [],
      gender: null,
      page: 1,
      hasMore: true,
      reports: [],
      filters: [],
      diseases: {
        disease_filters: [
          // {
          //   andOr: 'and',
          //   items: [
          //     // { andOr: 'and', cancerType: 2, relationalOperator: '<', age: '46' },
          //     // { andOr: 'and', cancerType: 2, relationalOperator: '>', age: '44' },
          //     { andOr: 'and', cancerType: 2, relationalOperator: '>', age: '44' },
          //     { andOr: 'and', cancerType: 5, relationalOperator: '>', age: '44' },
          //     { andOr: 'or', cancerType: 3, relationalOperator: '=', age: '45' },
          //     { andOr: 'or', cancerType: 1, relationalOperator: '>', age: '33' },
          //   ],
          // },
          // {
          //   andOr: 'or',
          //   items: [
          //     { andOr: 'or', cancerType: 3, relationalOperator: '=', age: '45' },
          //   ],
          // },
          // {
          //   andOr: 'or',
          //   items: [
          //     { andOr: 'or', cancerType: 1, relationalOperator: '>', age: '33' },
          //   ],
          // },
        ]
      },
      genes: {
        gene_filters: []
      },
      referrals: {
        referral_filters: [
        ]
      },
      more_filters: {
      },
      dob: {
        sign: '',
        start_date: '',
        end_date: ''
      },
      age: {
        sign: '',
        age: '',
        age_to: ''
      },
      clinician: null,
      records_count: 0,
      isDiseaseFilterActive: false,
      isGeneFilterActive: false,
      isReferralCriteriaFilterActive: false,
      isMoreFiltersActive: false,
      includeUMLS: false,
      setFilterHashes: () => {},
      org_clinicians: [],
      currently_active_patient_for_clinician_column: '',
      currently_hovered_patient_for_clinician_column: '',
      active_ordered_filters: [],
      showAdvancedFilters: false,
      advanced_filters: [],
      familyFilters: {
        number_of_people_to_meet_criteria: {
          relationalOperator: 'any',
          value: ''
        },
        relationship: 'anyone'
      },
      active_advanced_filter: '',
      advanced_filters_results: {
        status: '',
        query_result_ID: '',
        result: []
      },
      current_query_uid: '',
    };

    this.handleEditColumn = this.handleEditColumn.bind(this)
    this.openDeletePatientModal = this.openDeletePatientModal.bind(this);
    this.openDeleteReportModal = this.openDeleteReportModal.bind(this);
    this.closeDeletePatientModal = this.closeDeletePatientModal.bind(this);
    this.changeDiseaseFilters = this.changeDiseaseFilters.bind(this);
    this.changeReferralFilters = this.changeReferralFilters.bind(this);
    this.downloadCSV = this.downloadCSV.bind(this);
    this.handleReorderColumns = this.handleReorderColumns.bind(this)

    this.copyText = this.copyText.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);
    this.trackScrolling = this.trackScrolling.bind(this);
    this.onSavePDF = this.onSavePDF.bind(this);
    this.changeGeneFilters = this.changeGeneFilters.bind(this);
    this.changeMoreFilters = this.changeMoreFilters.bind(this);
    this.handleIsActiveChange = this.handleIsActiveChange.bind(this);
    this.openSaveReportModal = this.openSaveReportModal.bind(this);
    this.closeReportModal = this.closeReportModal.bind(this);
    this.openOverwriteReportModal = this.openOverwriteReportModal.bind(this);
    this.closeOverwriteReportModal = this.closeOverwriteReportModal.bind(this);
    this.saveNewReport = this.saveNewReport.bind(this);
    this.fetchReports = this.fetchReports.bind(this);
    this.loadDefaultColumns = this.loadDefaultColumns.bind(this);
    this.getSetFilterHashes = this.getSetFilterHashes.bind(this);
    this.queryProbands = this.queryProbands.bind(this);
    this.addFamilyTimeStampToProband = this.addFamilyTimeStampToProband.bind(this);
    this.loadGenesFromApi = this.loadGenesFromApi.bind(this);
    this.loadDiseasesFromAPI = this.loadDiseasesFromAPI.bind(this);
    this.viewPatient = this.viewPatient.bind(this);
    this.setLocalStorage = this.setLocalStorage.bind(this);
    this.setCurrentlyActivePatientForClinicianColumn = this.setCurrentlyActivePatientForClinicianColumn.bind(this);
    this.setCurrentlyHoveredPatientForClinicianColumn = this.setCurrentlyHoveredPatientForClinicianColumn.bind(this);
    this.loadPatientStatus = this.loadPatientStatus.bind(this);
    this.addPatientStatus = this.addPatientStatus.bind(this);
    this.setShowAdvancedFilters = this.setShowAdvancedFilters.bind(this);
    this.setAdvancedFiltersResults = this.setAdvancedFiltersResults.bind(this);
    this.setAdvancedFilters = this.setAdvancedFilters.bind(this);
    this.setActiveAdvancedFilter = this.setActiveAdvancedFilter.bind(this);
    this.refreshProbands = this.refreshProbands.bind(this);
    this.setFamilyFilters = this.setFamilyFilters.bind(this);
    this.setLoadingState = this.setLoadingState.bind(this);
    this.resetAdvancedFiltersResults = this.resetAdvancedFiltersResults.bind(this);
    this.setCurrentQueryUID = this.setCurrentQueryUID.bind(this);
  }

  getSetFilterHashes(setFilterHashes){
    this.setState({setFilterHashes: setFilterHashes});
  }

  async componentDidMount() {
    this.mounted = true
    await this.loadDefaultColumns();
    await this.loadGenesFromApi();
    await this.loadDiseasesFromAPI();
    await this.loadPatientStatus();
    await this.queryProbands();
    await this.fetchReports();
    this.props.setQueryProbands(this.refreshProbands);
    this.setOrgClinicians();
    resetFamilyRedux(this.props.dispatch);

    window.addEventListener('scroll', debounce(this.trackScrolling, 100), true);
  }

  async componentWillUnmount() {
    this.mounted = false
    window.removeEventListener('scroll', debounce(this.trackScrolling, 100), true);
  }

  async refreshProbands(){
    await this.loadPatientStatus()
    await this.queryProbands()
  }

  setOrgClinicians() {
    let org_clinicians = []

    for (let clinician of this.props.org_clinicians) {
      let clinician_object = {
        value: String(clinician.user_id),
        label: `${clinician.first_name} ${clinician.last_name}`
      }
      org_clinicians.push(clinician_object)
    }

    this.setState({ org_clinicians })
  }

  setLocalStorage() {
    const tokens = sessionStorage.getItem('famgenix_app_tokens');
    const extra_data = sessionStorage.getItem('extra_data');
    localStorage.setItem('famgenix_app_tokens', tokens);
    localStorage.setItem('extra_data', extra_data);
  }

  viewPatient(patient_id, renderer="CANVAS", event=null, member_id) {

    if(member_id){
      sessionStorage.setItem("member_id_toBeSelected", member_id)
    }

    if (event) {
      // check for right click
      var isRightMB;

      if ("which" in event.nativeEvent) { // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
        isRightMB = event.nativeEvent.which === 3;
      } else if ("button" in event.nativeEvent) {  // IE, Opera
        isRightMB = event.nativeEvent.button === 2;
      }

      if (renderer === "DOM" && (isRightMB || event.ctrlKey || event.metaKey)) {
        // temp set the sessionStorage to locaStorage
        this.setLocalStorage();

        const url = process.env.REACT_APP_SITE_URL+"/pedigree/" + patient_id;
        window.open(url, '_blank', 'noopener,noreferrer');
      } else if (isRightMB || event.ctrlKey || event.metaKey) {
        // temp set the sessionStorage to locaStorage
        this.setLocalStorage();

        const url = process.env.REACT_APP_SITE_URL+"/patient-profile/" + patient_id;
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        let url = url =
          route_helper.patient.patient_profile.replace(":member_id", patient_id) +
          "/#family-history";

        if (renderer === "DOM") {
          url =
            route_helper.pedigree.pedigree_root.replace(":member_id", patient_id) +
            "/#family-history";
        }

        this.props.history.push(url);
      }

    } else {
      let url = url =
        route_helper.patient.patient_profile.replace(":member_id", patient_id) +
        "/#family-history";

      if (renderer === "DOM") {
        url =
          route_helper.pedigree.pedigree_root.replace(":member_id", patient_id) +
          "/#family-history";
      }

      this.props.history.push(url);
    }
  }

  getLocaleDateString() {
    var formats = { "ar-SA": "DD/MM/YY", "bg-BG": "DD.MM.YYYY", "ca-ES": "DD/MM/YYYY", "zh-TW": "YYYY/MM/DD", "cs-CZ": "DD.MM.YYYY", "da-DK": "DD-MM-YYYY", "de-DE": "DD.MM.YYYY", "el-GR": "DD/MM/YYYY", "en-US": "MM/DD/YYYY", "fi-FI": "DD.MM.YYYY", "fr-FR": "DD/MM/YYYY", "he-IL": "DD/MM/YYYY", "hu-HU": "YYYY. MM. DD.", "is-IS": "DD.MM.YYYY", "it-IT": "DD/MM/YYYY", "ja-JP": "YYYY/MM/DD", "ko-KR": "YYYY-MM-DD", "nl-NL": "DD-MM-YYYY", "nb-NO": "DD.MM.YYYY", "pl-PL": "YYYY-MM-DD", "pt-BR": "DD/MM/YYYY", "ro-RO": "DD.MM.YYYY", "ru-RU": "DD.MM.YYYY", "hr-HR": "DD.MM.YYYY", "sk-SK": "DD. MM. YYYY", "sq-AL": "YYYY-MM-DD", "sv-SE": "YYYY-MM-DD", "th-TH": "DD/MM/YYYY", "tr-TR": "DD.MM.YYYY", "ur-PK": "DD/MM/YYYY", "id-ID": "DD/MM/YYYY", "uk-UA": "DD.MM.YYYY", "be-BY": "DD.MM.YYYY", "sl-SI": "DD.MM.YYYY", "et-EE": "DD.MM.YYYY", "lv-LV": "YYYY.MM.DD.", "lt-LT": "YYYY.MM.DD", "fa-IR": "MM/DD/YYYY", "vi-VN": "DD/MM/YYYY", "hy-AM": "DD.MM.YYYY", "az-Latn-AZ": "DD.MM.YYYY", "eu-ES": "YYYY/MM/DD", "mk-MK": "DD.MM.YYYY", "af-ZA": "YYYY/MM/DD", "ka-GE": "DD.MM.YYYY", "fo-FO": "DD-MM-YYYY", "hi-IN": "DD-MM-YYYY", "ms-MY": "DD/MM/YYYY", "kk-KZ": "DD.MM.YYYY", "ky-KG": "DD.MM.YY", "sw-KE": "MM/DD/YYYY", "uz-Latn-UZ": "DD/MM YYYY", "tt-RU": "DD.MM.YYYY", "pa-IN": "DD-MM-YY", "gu-IN": "DD-MM-YY", "ta-IN": "DD-MM-YYYY", "te-IN": "DD-MM-YY", "kn-IN": "DD-MM-YY", "mr-IN": "DD-MM-YYYY", "sa-IN": "DD-MM-YYYY", "mn-MN": "YY.MM.DD", "gl-ES": "DD/MM/YY", "kok-IN": "DD-MM-YYYY", "syr-SY": "DD/MM/YYYY", "dv-MV": "DD/MM/YY", "ar-IQ": "DD/MM/YYYY", "zh-CN": "YYYY/MM/DD", "de-CH": "DD.MM.YYYY", "en-GB": "DD/MM/YYYY", "es-MX": "DD/MM/YYYY", "fr-BE": "DD/MM/YYYY", "it-CH": "DD.MM.YYYY", "nl-BE": "DD/MM/YYYY", "nn-NO": "DD.MM.YYYY", "pt-PT": "DD-MM-YYYY", "sr-Latn-CS": "DD.MM.YYYY", "sv-FI": "DD.MM.YYYY", "az-Cyrl-AZ": "DD.MM.YYYY", "ms-BN": "DD/MM/YYYY", "uz-Cyrl-UZ": "DD.MM.YYYY", "ar-EG": "DD/MM/YYYY", "zh-HK": "DD/MM/YYYY", "de-AT": "DD.MM.YYYY", "en-AU": "DD/MM/YYYY", "es-ES": "DD/MM/YYYY", "fr-CA": "YYYY-MM-DD", "sr-Cyrl-CS": "DD.MM.YYYY", "ar-LY": "DD/MM/YYYY", "zh-SG": "DD/MM/YYYY", "de-LU": "DD.MM.YYYY", "en-CA": "DD/MM/YYYY", "es-GT": "DD/MM/YYYY", "fr-CH": "DD.MM.YYYY", "ar-DZ": "DD-MM-YYYY", "zh-MO": "DD/MM/YYYY", "de-LI": "DD.MM.YYYY", "en-NZ": "DD/MM/YYYY", "es-CR": "DD/MM/YYYY", "fr-LU": "DD/MM/YYYY", "ar-MA": "DD-MM-YYYY", "en-IE": "DD/MM/YYYY", "es-PA": "MM/DD/YYYY", "fr-MC": "DD/MM/YYYY", "ar-TN": "DD-MM-YYYY", "en-ZA": "YYYY/MM/DD", "es-DO": "DD/MM/YYYY", "ar-OM": "DD/MM/YYYY", "en-JM": "DD/MM/YYYY", "es-VE": "DD/MM/YYYY", "ar-YE": "DD/MM/YYYY", "en-029": "MM/DD/YYYY", "es-CO": "DD/MM/YYYY", "ar-SY": "DD/MM/YYYY", "en-BZ": "DD/MM/YYYY", "es-PE": "DD/MM/YYYY", "ar-JO": "DD/MM/YYYY", "en-TT": "DD/MM/YYYY", "es-AR": "DD/MM/YYYY", "ar-LB": "DD/MM/YYYY", "en-ZW": "MM/DD/YYYY", "es-EC": "DD/MM/YYYY", "ar-KW": "DD/MM/YYYY", "en-PH": "MM/DD/YYYY", "es-CL": "DD-MM-YYYY", "ar-AE": "DD/MM/YYYY", "es-UY": "DD/MM/YYYY", "ar-BH": "DD/MM/YYYY", "es-PY": "DD/MM/YYYY", "ar-QA": "DD/MM/YYYY", "es-BO": "DD/MM/YYYY", "es-SV": "DD/MM/YYYY", "es-HN": "DD/MM/YYYY", "es-NI": "DD/MM/YYYY", "es-PR": "DD/MM/YYYY", "am-ET": "DD/MM/YYYY", "tzm-Latn-DZ": "DD-MM-YYYY", "iu-Latn-CA": "DD/MM/YYYY", "sma-NO": "DD.MM.YYYY", "mn-Mong-CN": "YYYY/MM/DD", "gd-GB": "DD/MM/YYYY", "en-MY": "DD/MM/YYYY", "prs-AF": "DD/MM/YY", "bn-BD": "DD-MM-YY", "wo-SN": "DD/MM/YYYY", "rw-RW": "MM/DD/YYYY", "qut-GT": "DD/MM/YYYY", "sah-RU": "MM.DD.YYYY", "gsw-FR": "DD/MM/YYYY", "co-FR": "DD/MM/YYYY", "oc-FR": "DD/MM/YYYY", "mi-NZ": "DD/MM/YYYY", "ga-IE": "DD/MM/YYYY", "se-SE": "YYYY-MM-DD", "br-FR": "DD/MM/YYYY", "smn-FI": "DD.MM.YYYY", "moh-CA": "MM/DD/YYYY", "arn-CL": "DD-MM-YYYY", "ii-CN": "YYYY/mM/DD", "dsb-DE": "DD. MM. YYYY", "ig-NG": "DD/MM/YYYY", "kl-GL": "DD-MM-YYYY", "lb-LU": "DD/MM/YYYY", "ba-RU": "DD.MM.YY", "nso-ZA": "YYYY/MM/DD", "quz-BO": "DD/MM/YYYY", "yo-NG": "DD/MM/YYYY", "ha-Latn-NG": "DD/MM/YYYY", "fil-PH": "MM/DD/YYYY", "ps-AF": "DD/MM/YY", "fy-NL": "DD-MM-YYYY", "ne-NP": "MM/DD/YYYY", "se-NO": "DD.MM.YYYY", "iu-Cans-CA": "DD/MM/YYYY", "sr-Latn-RS": "DD.MM.YYYY", "si-LK": "YYYY-MM-DD", "sr-Cyrl-RS": "DD.MM.YYYY", "lo-LA": "DD/MM/YYYY", "km-KH": "YYYY-MM-DD", "cy-GB": "DD/MM/YYYY", "bo-CN": "YYYY/MM/DD", "sms-FI": "DD.MM.YYYY", "as-IN": "DD-MM-YYYY", "ml-IN": "DD-MM-YY", "en-IN": "DD-MM-YYYY", "or-IN": "DD-MM-YY", "bn-IN": "DD-MM-YY", "tk-TM": "DD.MM.YY", "bs-Latn-BA": "DD.MM.YYYY", "mt-MT": "DD/MM/YYYY", "sr-Cyrl-ME": "DD.MM.YYYY", "se-FI": "DD.MM.YYYY", "zu-ZA": "YYYY/MM/DD", "xh-ZA": "YYYY/MM/DD", "tn-ZA": "YYYY/MM/DD", "hsb-DE": "DD. MM. YYYY", "bs-Cyrl-BA": "DD.MM.YYYY", "tg-Cyrl-TJ": "DD.MM.YY", "sr-Latn-BA": "DD.MM.YYYY", "smj-NO": "DD.MM.YYYY", "rm-CH": "DD/MM/YYYY", "smj-SE": "YYYY-MM-DD", "quz-EC": "DD/MM/YYYY", "quz-PE": "DD/MM/YYYY", "hr-BA": "DD.MM.YYYY.", "sr-Latn-ME": "DD.MM.YYYY", "sma-SE": "YYYY-MM-DD", "en-SG": "DD/MM/YYYY", "ug-CN": "YYYY-MM-DD", "sr-Cyrl-BA": "DD.MM.YYYY", "es-US": "MM/DD/YYYY" }
    return formats[navigator.language] || 'DD/MM/YYYY';
  }

  openDeletePatientModal(patient_id) {
    this.setState({
      showDeletePatientModal: true,
      currentPatient: patient_id
    });
  }

  closeDeletePatientModal() {
    this.setState({
      showDeletePatientModal: false,
      currentPatient: null
    });
  }

  async loadGenesFromApi() {

    try{
        let data = await genetic_testing_api.get_genetic_testing()
        let umls_data = await genetic_testing_api.get_umls_genetic_testing(this.props.user.clinician_id)

      await this.props.dispatch(static_list_actions.initialize_genetic_testings(data));
      await this.props.dispatch(static_list_actions.initialize_genetic_testings_umls(umls_data.proband_genes));
    } catch (error) {
      console.log(error);
    }
  }

  async loadPatientStatus() {
    try{
        let status = await family_api.get_patient_status_list()
        await this.props.dispatch(static_list_actions.intialize_patients_status(status));
    } catch (error) {
      console.log(error);
    }
  }

  async loadDiseasesFromAPI() {

    try {
        let data = await disease_api.get_disease();
        let umls = await disease_api.get_umls_diseases(this.props.user.clinician_id)
        let diseases = data.diseases.sort((a, b) => {
          if (a.disease_name < b.disease_name) return -1;
          if (a.disease_name > b.disease_name) return 1;
          return 0;
        });


        const uniqueUMLS = Array.from(new Set(umls.umls_diseases.map(a=>a.umls_name))).map(name=>{
          return umls.umls_diseases.find(a =>a.umls_name === name)
        })

        let umls_diseases = uniqueUMLS.sort((a, b) => {
          if (a.umls_name < b.umls_name) return -1;
          if (a.umls_name > b.umls_name) return 1;
          return 0;
        })

        await this.props.dispatch(static_list_actions.initialize_diseases(diseases));
        await this.props.dispatch(static_list_actions.intitialize_umls(umls_diseases))
    } catch (error) {
      console.log(error);
    }
  }

  async onDeletePatient(proband_id) {
    if (parseToInt(proband_id)) {
      try {
        await family_api.delete_family({ proband_id });

        const cloned = cloneDeep(this.state.probands);
        const new_probands = cloned.filter((proband) => {
          if (parseToInt(proband.id) !== parseToInt(proband_id)) {
            return proband;
          }
        });

        this.setState({ probands: new_probands });

      } catch (error) {
        console.log(error)
      }
    }
  }

  openSaveReportModal(){
    this.setState({
      showSaveReport: true
    });
  }

  closeReportModal(){
    this.setState({
      showSaveReport: false
    });
  }

  openOverwriteReportModal(reportTitle){
    this.setState({ showOverwriteReport: [true, reportTitle] });
  }

  closeOverwriteReportModal(){
    this.setState({ showOverwriteReport: [false, ''] });
  }

  async overWriteReport(reportTitle){
    this.setState({ loading: true })
    const payload = {
      filters: {
        search: this.props.searchFilter.search_text,
        gender: this.state.gender,
        diseases: this.state.diseases,
        referrals: this.state.referrals,
        genes: this.state.genes,
        dob: this.state.dob,
        age: this.state.age,
        clinician: this.state.clinician,
        more_filters: this.state.more_filters,
        includeUMLS: this.state.includeUMLS,
        advanced_uid: this.state.current_query_uid,
        active_advanced_filters: this.state.active_advanced_filter,
        advanced_filters: this.state.advanced_filters
      },
      reportTitle: reportTitle,
      columns: this.state.allColumns,
      user_id: this.props.user.user_id
    }

    try {
      await userAccountApi.overwrite_report(payload, this.props.user.clinician_id)
      this.closeReportModal();

    } catch (error) {
      console.log(error);
    }

    helpers.delay(.2);
    this.fetchReports();
    this.setState({loading: false});
  }

  ciEquals(a, b) {
    return typeof a === 'string' && typeof b === 'string'
      ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
      : a === b;
  }

  async saveNewReport(reportTitle) {
    let reports = this.state.reports.filter(report => this.ciEquals(report.title, reportTitle));
    if (reports.length > 0) {
      this.openOverwriteReportModal(reportTitle);
    }
    else {
      this.setState({ loading: true })

      const payload = {
        filters: {
          search: this.props.searchFilter.search_text,
          gender: this.state.gender,
          diseases: this.state.diseases,
          referrals: this.state.referrals,
          genes: this.state.genes,
          dob: this.state.dob,
          age: this.state.age,
          clinician: this.state.clinician,
          more_filters: this.state.more_filters,
          advanced_uid: this.state.current_query_uid,
          active_advanced_filters: this.state.active_advanced_filter,
          advanced_filters: this.state.advanced_filters
        },
        reportTitle: reportTitle,
        columns: this.state.allColumns,
        user_id: this.props.user.user_id
      }

      try {
        await userAccountApi.save_new_query_report(payload, this.props.user.clinician_id)
        this.closeReportModal();

      } catch (error) {
        console.log(error)
      }

      helpers.delay(.2)
      this.fetchReports()
      this.setState({loading: false})
    }
  }

  async fetchReports() {
    try{
      let reports = await userAccountApi.get_reports(this.props.user.organization_id, this.props.user.clinician_id);
      this.setState({reports: reports})
    } catch(error){
      this.setState({ errorMessages: [error.message] })
    }
  }

  loadReport = async(report) => {
    this.setState({loading: true})
      if(report == null){
       await this.handleClearFilter()
       await this.state.setFilterHashes();
       await this.loadDefaultColumns()
      }else{

       try{
         let report_data  = await userAccountApi.load_report(report, this.props.user.clinician_id);

         if ('advanced_uid' in report_data.filters && 
              report_data.filters.advanced_uid !== undefined && 
              report_data.filters.advanced_uid !== "") {
            
              let uid = report_data.filters.advanced_uid
              let advanced_filters = report_data.filters.advanced_filters
              let active_advanced_filters = report_data.filters.active_advanced_filters
            await this.runReportAdvancedQuery(uid, advanced_filters, active_advanced_filters)
         }else{
            let filters = report_data.filters
            let columns = report_data.columns
            const payload = {
              search: filters.search_text,
              gender: filters.gender,
              diseases: filters.diseases,
              referrals: filters.referrals,
              genes: filters.genes,
              more_filters: filters.more_filters,
              dob: filters.dob,
              age: filters.age,
              clinician: filters.clinician
            };

            this.resultFilterRef.current.handleHideAllFilters();

            if(filters.diseases.disease_filters.length > 0){
             this.resultFilterRef.current.handleClickAddFiltersOption(null, 'disease')
            }
            if(filters.genes.gene_filters.length > 0){
             this.resultFilterRef.current.handleClickAddFiltersOption(null, 'genetic_testing')
            }
            if(filters.referrals.referral_filters.length > 0){
             this.resultFilterRef.current.handleClickAddFiltersOption(null, 'referral_criteria')
            }
            if(!isEmpty(filters.more_filters)){
             this.resultFilterRef.current.handleClickAddFiltersOption(null, 'more')
            }
            let probands = await family_api.query_probands(
              this.props.user.clinician_id, payload
            );
            let selected_columns = columns.filter(item => item.checked)
            this.addDiseasesToProband(probands.members, probands.member_diseases)
            this.addGenesToProband(probands.members, probands.member_genes)
            this.addPatientStatus(probands.members)
            this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
            this.setState({
              probands: probands.members,
              member_diseases: probands.member_diseases,
              member_genes: probands.member_genes,
              member_referral_criteria: probands.member_referral_criteria,
              search: filters.search_text,
              gender: filters.gender,
              diseases: filters.diseases,
              referrals: filters.referrals,
              genes: filters.genes,
              dob: filters.dob,
              age: filters.age,
              more_filters: filters.more_filters,
              columns: selected_columns,
              allColumns: report_data.columns,
              records_count: probands.records_count,
              clinician: filters.clinician
            });
 
            if(this.diseaseFilterRef.current) this.diseaseFilterRef.current.loadReportSetFilters(filters.diseases)
            if(this.geneTestingFilterRef.current) this.geneTestingFilterRef.current.loadReportSetFilters(filters.genes)
            if(this.referralFilterRef.current) this.referralFilterRef.current.loadReportSetFilters(filters.referrals)
            if(this.moreFilterRef.current) this.moreFilterRef.current.loadReportSetFilters(filters.more_filters)     
        }
       }
        catch(error){
         console.log(error)
      }
    }

    this.setState({loading: false})

  }

  async deleteReport() {
    this.setState({loading: true})
    try {
      await userAccountApi.delete_report(this.state.showDeleteReportModal[1].value, this.props.user.clinician_id);
      await this.fetchReports();
      if(this.state.showDeleteReportModal[1].value === this.queryToolbarRef.current.state.currentActiveReport.value || this.queryToolbarRef.current.state.currentActiveReport.value === null){
        await this.queryToolbarRef.current.selectRef.select.clearValue();
        await this.handleClearFilter();
      }
    }
    catch (error) {
      console.log(error)
    }
    this.setState({ showDeleteReportModal: [false, '']});
    this.setState({loading: false})
  }

  openDeleteReportModal(report){
    this.setState({ showDeleteReportModal: [true, report] });
  }

  closeDeleteReportModal(){
    this.setState({ showDeleteReportModal: [false, ''] });
  }

  handleReorderColumns(columns, all_columns) {
    this.setState({ columns: columns, allColumns: all_columns})
  }

  handleEditColumn(columns, all_columns) {
    this.addDiseasesToProband(this.state.probands, this.state.member_diseases)
    this.addGenesToProband(this.state.probands, this.state.member_genes)
    this.addReferralCriteriasToProband(this.state.probands, this.state.member_referral_criteria)
    this.addPatientStatus(this.state.probands)
    this.setState({ columns: columns, allColumns: all_columns})
  }

  showColumn(key) {
    return this.state.columns.includes(key)
  }

  async loadDefaultColumns(){
    let selected_columns
      try{
          this.setState({loading: true})
          let columns = await userAccountApi.load_default_columns(this.props.user.organization_id, this.props.user.clinician_id)

          if(columns.default_columns !== null && columns.default_columns !== undefined ){
            if (columns.default_columns.length !== json_columns.length){
              const objectsOnlyInArray1 = json_columns.filter(obj1 => !columns.default_columns.find(obj2 => obj2.value === obj1.value));
              objectsOnlyInArray1.forEach(column =>{
                column['checked'] = false
                columns.default_columns.push(column)
              })
            }
            this.columnRef = columns.default_columns
            selected_columns = columns.default_columns.filter(item => item.checked)

            this.setState({ columns: selected_columns, allColumns: columns.default_columns})
          }else{
            this.columnRef = json_columns
            this.setState({allColumns: json_columns})
            selected_columns = json_columns.filter(item => item.checked)
            this.setState({ columns: selected_columns})
          }
      }catch(err){
        console.log(err)
      }finally{
        this.setState({loading: false})
      }
    }

  queryProbands = async() => {
    try{
      this.setState({loading: true})
      const payload = {
        search: this.props.searchFilter.search_text,
        gender: this.state.gender,
        page: this.state.page,
        diseases: this.state.diseases,
        includeUMLS: this.state.includeUMLS,
        referrals: this.state.referrals,
        genes: this.state.genes,
        dob: this.state.dob,
        age: this.state.age,
        clinician: this.state.clinician,
        more_filters: this.state.more_filters
      };

      let probands = await family_api.query_probands(
        this.props.user.clinician_id, payload
      );

      this.addDiseasesToProband(probands.members, probands.member_diseases)
      this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
      this.addGenesToProband(probands.members, probands.member_genes)
      this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
      this.addPatientStatus(probands.members)
      probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
      this.setState({
        probands: probands.members,
        member_diseases: probands.member_diseases,
        member_genes: probands.member_genes,
        member_referral_criteria: probands.member_referral_criteria,
        records_count: probands.records_count
      });
    } catch (error){
      this.setState({ errorMessages: [error.message] })
    }finally{
      if(this.mounted) {
        this.setState({ loading: false });
      }
    }

  }

  addFamilyTimeStampToProband(probands, timeStamps){
    let addtimestamp = timeStamps.reduce((results, time) => {
      (results[time.family_id] = results[time.family_id] || []).push(time)
      return results
    }, {})

    for (let patient of probands) {
      if (patient.family_id in addtimestamp) {
        patient.family_last_modified = addtimestamp[patient.family_id][0].last_modified
      }
    }
  }


  addPatientStatus(members){
    const complete = 'Complete'
    const inProgress = 'In progress'

    if(!isEmpty(this.props.static_list.patients_status)){
      for(let patient of members){
        if(this.props.static_list.patients_status['complete_onboarding']
            && this.props.static_list.patients_status['complete_onboarding'].includes(patient.family_id)){
                patient.patient_status = complete

              }else if(this.props.static_list.patients_status['in_progress']
              && this.props.static_list.patients_status['in_progress'].includes(patient.family_id)){
                  patient.patient_status = inProgress
        }
      }
    }
  }

  addDiseasesToProband(probands, diseases) {
    let group_diseases = []

    for (let diseases_list of diseases) {
      diseases_list.name = this.props.static_list.diseases.find(disease => {
        return disease.id == diseases_list.disease_id
      })
      group_diseases.push(diseases_list)
    }
    let groupMemberDiseases = diseases.reduce((results, disease) => {
      (results[disease.member_id] = results[disease.member_id] || []).push(disease)
      return results
    }, {})

    for (let patient of probands) {
      if (patient.id in groupMemberDiseases) {
        patient.diseases = groupMemberDiseases[patient.id]
      }
    }
  }

  addGenesToProband(probands, genes) {
    let group_genes = []
    for (let gene_list of genes) {
      gene_list.name = this.props.static_list.genetic_testings.find(gene => {
        return gene.id == gene_list.gene_id
      })
      group_genes.push(gene_list)
    }
    let groupMemberGenes = genes.reduce((results, genes) => {
      (results[genes.member_id] = results[genes.member_id] || []).push(genes)
      return results
    }, {})

    for (let patient of probands) {
      if (patient.id in groupMemberGenes) {
        patient.gene_summary = groupMemberGenes[patient.id]
      }
    }
  }

  addReferralCriteriasToProband(probands, referral_criterias){
    for(let proband of probands){
      let proband_referral_condition_array = []
      if(proband.id in referral_criterias){
        for (let criteria of referral_criterias[proband.id]){
          proband_referral_condition_array.push(criteria.condition_name)
        }
      }
      proband_referral_condition_array = proband_referral_condition_array.filter((v, i, a) => a.indexOf(v) === i)
      proband.referral_condition = proband_referral_condition_array
      let proband_referral_criteria_string = proband.referral_condition.join();
      let stringforReferralCriteria = this.getReferralCriteriaString(proband_referral_criteria_string)

      proband.referral_criteria_string = stringforReferralCriteria;
    }
  }

  getReferralCriteriaString(proband_referral_criteria_string){
    let stringforReferralCriteria = ""
    if(proband_referral_criteria_string.includes('Breast/Ovarian')){
      stringforReferralCriteria += "Breast/Ovarian" + ", ";
    }
    if(proband_referral_criteria_string.includes('Colorectal')){
      stringforReferralCriteria += "Colorectal" + ", ";
    }
    if(proband_referral_criteria_string.includes('Other')){
      stringforReferralCriteria += "Other" + ", ";
    }
    if(proband_referral_criteria_string.includes('Gene')){
      stringforReferralCriteria += "Gene" + ", ";
    }
    stringforReferralCriteria = stringforReferralCriteria.slice(0, -2)

    return stringforReferralCriteria;
  }

  async handleIsActiveChange(filter_name, isActive){
    if(filter_name === 'disease'){
      this.setState({ isDiseaseFilterActive: isActive })
    }
    else if(filter_name === 'gene'){
      this.setState({ isGeneFilterActive: isActive })
    }
    else if(filter_name === 'referral'){
      this.setState({ isReferralCriteriaFilterActive: isActive })
    }
    else if(filter_name === 'more_filters'){
      this.setState({ isMoreFiltersActive: isActive })
    }
  }

  async changeReferralFilters(referral_filters, isActive) {
    if(isActive){
      this.setState({
        referrals: {
          referral_filters: referral_filters
        }
      });
    }
    else{
      this.setState({
        referrals: {
          referral_filters: [
          ]
        }
      });
    }


    const payload = {
      search: this.props.searchFilter.search_text,
      gender: this.state.gender,
      page: this.state.page,
      diseases: this.state.diseases,
      includeUMLS: this.state.includeUMLS,
      referrals: {
        referral_filters: isActive ? referral_filters : []
      },
      genes: this.state.genes,
      dob: this.state.dob,
      age: this.state.age,
      clinician: this.state.clinician
    };

    let probands = await family_api.query_probands(
      this.props.user.clinician_id, payload
    );
    this.addDiseasesToProband(probands.members, probands.member_diseases)
    this.addGenesToProband(probands.members, probands.member_genes)
    this.addPatientStatus(probands.members)
    this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    this.setState({
      probands: probands.members,
      member_diseases: probands.member_diseases,
      member_genes: probands.member_genes,
      member_referral_criteria: probands.member_referral_criteria,
      records_count: probands.records_count,
      hasMore: true,
      page: 1
    });

    if(this.state.isGeneFilterActive || this.state.isDiseaseFilterActive || this.state.isMoreFiltersActive){
      await this.queryProbands();
    }

  }

  async changeDiseaseFilters(disease_filters, includeUMLS, isActive) {
    if(isActive){
      this.setState({
        diseases: {
          disease_filters: disease_filters
        },
        includeUMLS: includeUMLS
      });
    }
    else{
      this.setState({
        diseases: {
          disease_filters: [
          ]
        }
      });
    }

    const payload = {
      search: this.props.searchFilter.search_text,
      gender: this.state.gender,
      page: this.state.page,
      diseases: {
        disease_filters: isActive ? disease_filters : []
      },
      includeUMLS: includeUMLS,
      referrals: this.state.referrals,
      genes: this.state.genes,
      dob: this.state.dob,
      age: this.state.age,
      clinician: this.state.clinician
    };

    let probands = await family_api.query_probands(
      this.props.user.clinician_id, payload
    );

    this.addDiseasesToProband(probands.members, probands.member_diseases)
    this.addGenesToProband(probands.members, probands.member_genes)
    this.addPatientStatus(probands.members)
    this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    this.setState({
      probands: probands.members,
      member_diseases: probands.member_diseases,
      member_genes: probands.member_genes,
      member_referral_criteria: probands.member_referral_criteria,
      records_count: probands.records_count,
      hasMore: true,
      page: 1
    });

    if(this.state.isGeneFilterActive || this.state.isReferralCriteriaFilterActive || this.state.isMoreFiltersActive){
      await this.queryProbands();
    }

  }

  async changeGeneFilters(genes_filters, isActive) {
    if(isActive){
      this.setState({
        genes: {
          gene_filters: genes_filters
        }
      });
    }
    else{
      this.setState({
        genes: {
          gene_filters: []
        }
      });
    }


    const payload = {
      search: this.props.searchFilter.search_text,
      gender: this.state.gender,
      page: this.state.page,
      diseases: this.state.diseases,
      referrals: this.state.referrals,
      includeUMLS: this.state.includeUMLS,
      genes: {
        gene_filters: isActive ? genes_filters : []
      },
      dob: this.state.dob,
      age: this.state.age,
      clinician: this.state.clinician
    };

    let probands = await family_api.query_probands(
      this.props.user.clinician_id, payload
    );

    this.addGenesToProband(probands.members, probands.member_genes)
    this.addDiseasesToProband(probands.members, probands.member_diseases)
    this.addPatientStatus(probands.members)
    this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    this.setState({
      probands: probands.members,
      member_diseases: probands.member_diseases,
      member_genes: probands.member_genes,
      member_referral_criteria: probands.member_referral_criteria,
      records_count: probands.records_count,
      hasMore: true,
      page: 1
    });

    if(this.state.isDiseaseFilterActive || this.state.isReferralCriteriaFilterActive || this.state.isMoreFiltersActive){
      await this.queryProbands();
    }

  }

  async changeMoreFilters(more_filters, isActive){
    if(isActive){
      this.setState({ more_filters: more_filters });
    }
    else{
      more_filters.age = null
      more_filters.age_operator = "="
      more_filters.age_to = null
      more_filters.dob_from = null
      more_filters.dob_operator = "="
      more_filters.dob_to = null
      more_filters.gender = null
      more_filters.clinician = null
      this.setState({ more_filters: more_filters });
    }
    const payload = {
      search: this.props.searchFilter.search_text,
      gender: more_filters.gender,
      page: this.state.page,
      diseases: this.state.diseases,
      includeUMLS: this.state.includeUMLS,
      referrals: this.state.referrals,
      genes: this.state.genes,
      more_filters: more_filters,
      dob:{
          sign: more_filters.dob_operator,
          start_date: more_filters.dob_from,
          end_date: more_filters.dob_to
      },
      age: {
        sign: more_filters.age_operator,
        age: more_filters.age,
        age_to: more_filters.age_to
      },
      clinician: more_filters.clinician
    };

    let probands = await family_api.query_probands(
      this.props.user.clinician_id, payload
    );

    this.addGenesToProband(probands.members, probands.member_genes)
    this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    this.addDiseasesToProband(probands.members, probands.member_diseases)
    this.addPatientStatus(probands.members)
    this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    this.setState({
      probands: probands.members,
      member_diseases: probands.member_diseases,
      member_genes: probands.member_genes,
      member_referral_criteria: probands.member_referral_criteria,
      records_count: probands.records_count,
      hasMore: true,
      page: 1,
      gender: more_filters.gender,
      dob:{
        sign: more_filters.dob_operator,
        start_date: more_filters.dob_from,
        end_date: more_filters.dob_to
      },
      age: {
        sign: more_filters.age_operator,
        age: more_filters.age,
        age_to: more_filters.age_to
      },
      clinician: more_filters.clinician
    });

    if(this.state.isGeneFilterActive || this.state.isReferralCriteriaFilterActive || this.state.isDiseaseFilterActive){
      await this.queryProbands();
    }

  }

  async runAdvancedQuery(){
    try{
      // let umls_genes = this.props.static_list.genetic_testings_umls
      // let umls_diseases = this.props.static_list.umls_diseases

      // let payload = buildQueryPayload(this.state.active_advanced_filter, this.state.advanced_filters, this.state.familyFilters, umls_genes, umls_diseases, false)

      // doesn't need to rebuild, just send the query id
      let query_id = this.state.current_query_uid
      if (!query_id) return;

      let payload = {
        queryID: query_id
      }

      let request = await family_api.query_search(payload)

      let result_payload = {
        query_result_ID: request.query_result_ID
      }
      this.setAdvancedFiltersResults(result_payload)
    }
    catch(e){
      console.log(e.stack)
    }
  }
  async runReportAdvancedQuery(query_id, advanced_filters, active_advanced_filters){
    try{
      let payload = {
        queryID: query_id
      }
      let request = await family_api.query_search(payload)

      let result_payload = {
        query_result_ID: request.query_result_ID
      }

      this.setActiveAdvancedFilter(active_advanced_filters)
      this.setAdvancedFilters(advanced_filters)
      this.setCurrentQueryUID(request.query_uid)
      this.setAdvancedFiltersResults(result_payload)
    }
    catch(e){
      console.log(e.stack)
    }
  }

  async handleClearFilter() {
    const payload = {
      search: '',
      gender: null,
      page: 1,
      diseases: {
        disease_filters: []
      },
      referrals: {
        referral_filters: []
      },
      genes: {
        gene_filters: []
      },
      more_filters: {},
      dob: {
        sign: '',
        start_date: '',
        end_date: ''
      },
      age: {
        sign: '',
        age: '',
        age_to: ''
      },
      clinician: null,
      includeUMLS: false
    };

    this.resetAdvancedFiltersResults()
    this.setState({ active_ordered_filters: [] })

    let probands = await family_api.query_probands(
      this.props.user.clinician_id, payload
    );
    this.addDiseasesToProband(probands.members, probands.member_diseases)
    this.addGenesToProband(probands.members, probands.member_genes)
    this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    this.addPatientStatus(probands.members)
    probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    helper_search.updateSearchText(this.props.dispatch, '');
    this.setState({
      diseases: {
        disease_filters: []
      },
      genes: {
        gene_filters: []
      },
      referrals: {
        referral_filters: []
      },
      more_filters: {},
      probands: probands.members,
      member_diseases: probands.member_diseases,
      member_genes: probands.member_genes,
      member_referral_criteria: probands.member_referral_criteria,
      records_count: probands.records_count,
      includeUMLS: false,
      gender: null,
      dob: {
        sign: '',
        start_date: '',
        end_date: ''
      },
      age: {
        sign: '',
        age: '',
        age_to: ''
      },
      clinician: null,
      hasMore: true,
      page: 1,
      isDiseaseFilterActive: false,
      isGeneFilterActive: false,
      isReferralCriteriaFilterActive: false,
      isMoreFiltersActive: false
    });

  }

  downloadCSV() {
    let csvHeaderLabels = [];
    let headers = []
    let csvData = []
    let csvRows = []
    let headersData = this.state.columns.forEach((item) => {
      headers.push(item.value)
      csvHeaderLabels.push(item.label)
    })

    csvRows.push(csvHeaderLabels.join(","))

    this.state.probands.forEach((proband) => {
      let birth_date = ' '
      let member_disease = ''
      let genes = ' '
      let age = null
      if (proband.dob) {
        birth_date = proband.dob
      }
      if(proband.diseases) {
        proband.diseases.forEach(disease=> {
            if(disease.name){
              member_disease += ` ${disease.name.disease_name} ${disease.age_diagnosed_string} `
            }else if(disease.umls_name){
              member_disease += ` ${disease.umls_name} ${disease.age_diagnosed_string}`
            }
        })
      }
      if(proband.gene_summary){
        proband.gene_summary.forEach(gene=>{
          if(gene.name){
            genes +=  `${gene.name.gene} ${gene.result} `;
          }else if(gene.umls_name){
            genes +=  `${gene.umls_name} ${gene.result} `
          }
        })
      }
      if(proband.age){
        age = proband.age_string ? proband.age_string : proband.age
      }
      let row = {
        patient_id: proband.patient_id,
        last_name: proband.last_name,
        first_name: proband.first_name,
        gender: proband.gender,
        dob: birth_date,
        modified_at: moment(proband.modified_at).format(this.getLocaleDateString()),
        age: age,
        diseases: member_disease,
        gene_summary: genes

      }
      csvData.push(row)
    });

    for(let row of csvData){
      let values = headers.map(header=>{
        return row[header]
      })
      csvRows.push(values.join(","))
    }


    csvRows = csvRows.join("\n")
    var downloadLink = document.createElement("a");
    var blob = new Blob(["\ufeff", csvRows]);
    var url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = "data.csv";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  copyText() {

    let table = document.querySelector('table');
    let range, sel;
    let updatedTable = table.cloneNode(true)
    updatedTable.id = 'copy-table'
    let removeButtons = updatedTable.getElementsByClassName('middle')
    while (removeButtons[0]) {
      removeButtons[0].parentNode.removeChild(removeButtons[0])
    }
    document.body.appendChild(updatedTable)

    //set width so it fits on portrait mode when pasted in word
    document.getElementById('copy-table').style.width = '100px';

    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();

      try {
        range.selectNodeContents(updatedTable);
        sel.addRange(range);
      } catch (e) {
        console.log(e)
      }
      document.execCommand('copy');
      document.body.removeChild(updatedTable)
    }
    sel.removeAllRanges();

  }

  async onSavePDF() {
    var doc = new jsPDF({
      orientation: 'landscape',
      floatPrecision: "smart",
      unit: 'px'
    });
    let headers = []
    let rows = []
    let headersData = this.state.columns.forEach((item) => {
      headers.push(item)
    })

    headers = createHeaders(headers)
    function createHeaders(keys) {
      return keys.map(key => ({
        dataKey: key.value,
        header: key.label,
      }));
    };

    //include for referral criteria here
    this.state.probands.forEach((proband) => {
      let first_name =""
      let last_name = ""
      let patient_id = ''
      let birth_date = ''
      let member_disease = ""
      let genes = ''
      let age = ''
      let referal_criteria = ""
      if(proband.first_name){
        first_name = proband.first_name
      }
      if(proband.last_name){
        last_name = proband.last_name
      }
      if(proband.patient_id){
        patient_id = proband.patient_id
      }
      if (proband.dob) {
        birth_date = proband.dob
      }
      if(proband.diseases) {
        proband.diseases.forEach(disease=> {
            if(disease.name){
              member_disease += ` ${disease.name.disease_name} ${disease.age_diagnosed_string} `
            }else if(disease.umls_name){
              member_disease += ` ${disease.umls_name} ${disease.age_diagnosed_string}`
            }
        })
      }
      if(proband.gene_summary){
        proband.gene_summary.forEach(gene=>{
          if(gene.name){
            genes +=  `${gene.name.gene} ${gene.result} `;
          }else if(gene.umls_name){
            genes +=  `${gene.umls_name} ${gene.result} `
          }
        })
      }
      if(proband.age > 0){
        age = proband.age_string ? proband.age_string : proband.age
      }
      if(proband.referral_criteria_string){
        referal_criteria =  proband.referral_criteria_string
      }
      let row = {
        patient_id: patient_id,
        last_name: last_name,
        first_name: first_name,
        gender: proband.gender,
        dob: birth_date,
        modified_at: moment(proband.modified_at).format(this.getLocaleDateString()),
        age: age,
        diseases: member_disease,
        gene_summary: genes,
        referral_criteria: referal_criteria
      }
      rows.push(row)
    });

    doc.autoTable({
      columns: headers,
      body: rows,
      bodyStyles: { fontSize: 11, valign: 'middle'},
      styles:{valign: 'bottom', minCellWidth: 50},

    })
    doc.save('patient-data.pdf')
  }

  getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
  }

  async trackScrolling() {
    if (this.state.loading || !this.state.hasMore || this.state.showAdvancedFilters) return;

    if($(window).scrollTop() + $(window).height() > this.getDocHeight() - 100) {
      console.log("bottom!");

    // if (
    //   window.innerHeight + document.documentElement.scrollTop
    //   === document.documentElement.offsetHeight
    // ) {
      // console.log('bottom reached');
      const new_page = this.state.page + 1;
      const payload = {
        search: this.props.searchFilter.search_text,
        gender: this.state.gender,
        page: new_page,
        diseases: this.state.diseases,
        referrals: this.state.referrals,
        genes: this.state.genes,
        dob: this.state.dob,
        age: this.state.age,
        clinician: this.state.clinician
      };

      this.setState({ loading: true, errorMessages: [] }, async () => {
        try {
          const probands = await family_api.query_probands(
            this.props.user.clinician_id, payload
          );
          this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
          probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
          this.addDiseasesToProband(probands.members, probands.member_diseases)
          this.addGenesToProband(probands.members, probands.member_genes)
          this.addPatientStatus(probands.members)
          this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
          let temp_probands = cloneDeep(this.state.probands);
          const new_probands = temp_probands.concat(probands.members);
          const stop_loading = probands.members.length === 0;

          this.setState({
            page: temp_probands.length === new_probands.length ? 1 : new_page,
            probands: new_probands,
            member_diseases: probands.member_diseases,
            member_genes: probands.member_genes,
            member_referral_criteria: probands.member_referral_criteria,
            records_count: probands.records_count,
            hasMore: !stop_loading
          });
        } catch (error) {
          this.setState({ errorMessages: [error.message] });
        } finally {
          this.setState({ loading: false });
        }
      });
    } else {
      console.log('not at bottom');
    }

  }

  openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  async saveClinician(proband){
    if(!('clinicians' in proband)) return;
    try {
      let payload = {
        clinicians: proband.clinicians,
        proband_id: proband.id
      }
      await family_api.save_family_clinicians(payload)

    } catch (err) {
      console.log(err);
    }

  }

  async changeClinician(patient, clinician_array) {
    //change the clinician object of the patient from the probands state
    let probands = cloneDeep(this.state.probands)
    for(let proband of probands){
      if(patient.id == proband.id){
        proband.clinicians = cloneDeep(clinician_array)
        await this.saveClinician(proband)
        break;
      }
    }
    //call saveClinician

    this.setState({ probands })
  }

  setCurrentlyActivePatientForClinicianColumn(id){
    if(this.state.currently_active_patient_for_clinician_column != id){
      this.setState({ currently_active_patient_for_clinician_column: id })
    }
  }

  setCurrentlyHoveredPatientForClinicianColumn(id){
    if(this.state.currently_hovered_patient_for_clinician_column != id){
      this.setState({ currently_hovered_patient_for_clinician_column: id })
    }
  }

  getCliniciansLabel(clinicians){
    let copy_clinicians = cloneDeep(clinicians)
    let clinicians_label = []
    for (let clinician of copy_clinicians){
      clinicians_label.push(clinician.label)
    }

    return clinicians_label.join(', ')
  }

  setShowAdvancedFilters(showAdvancedFilters){
    this.setState({ showAdvancedFilters })
  }

  async setAdvancedFiltersResults(results_payload){
    this.setShowAdvancedFilters(false);
    this.setLoadingState(true);
    let results = await family_api.get_query_results(results_payload);
    this.setState({ advanced_filters_results: results })

    if('result' in results && results.result.length > 0 && this.state.loading){
      this.setLoadingState(false);
    }

    while(results.status != 'Completed'){
      // if user selects a patient to view or goes to any other page, then stop the background loop
      await helpers.delay(0.5);
      const pathName = window.location.pathname;
      if(!pathName.includes('query')){
        break;
      }

      results = await family_api.get_query_results(results_payload);
      this.setState({ advanced_filters_results: results })

      if('result' in results && results.result.length > 0 && this.state.loading){
        this.setLoadingState(false);
      }
    }

    if(results.status == 'Completed'){
      this.setLoadingState(false);
    }
  }

  setCurrentQueryUID(current_query_uid){
    this.setState({ current_query_uid })
  }

  async resetAdvancedFiltersResults(){
    let advanced_filters_results_empty = {
      status: '',
      query_result_ID: '',
      result: []
    };

    this.setCurrentQueryUID('')
    this.setState({ advanced_filters_results: advanced_filters_results_empty })
    this.setAdvancedFilters([])
    this.setActiveAdvancedFilter('probands')
  }

  setAdvancedFilters(advanced_filters){
    this.setState({ advanced_filters })
  }

  setActiveAdvancedFilter(active_advanced_filter){
    this.setState({ active_advanced_filter })
  }

  setFamilyFilters(familyFilters){
    this.setState({ familyFilters })
  }

  setLoadingState(loading){
    this.setState({ loading });
  }

  render() {
    const probands = this.state.probands;
    let currentPatient = probands.find((proband) => proband.id === this.state.currentPatient);

    let results = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? this.state.advanced_filters_results.result : this.state.probands

    return (
      <React.Fragment>

        {this.state.showAdvancedFilters ?
            <AdvancedFilters
              setAdvancedFilters={this.setAdvancedFilters}
              setAdvancedFiltersResults={this.setAdvancedFiltersResults}
              setShowAdvancedFilters={this.setShowAdvancedFilters}
              setActiveAdvancedFilter={this.setActiveAdvancedFilter}
              setFamilyFilters={this.setFamilyFilters}
              active_advanced_filter={this.state.active_advanced_filter}
              advanced_filters_results={this.state.advanced_filters_results}
              advanced_filters={this.state.advanced_filters}
              resultFilterRef={this.resultFilterRef}
              familyFilters={this.state.familyFilters}
              setLoadingState={this.setLoadingState}
              setCurrentQueryUID={this.setCurrentQueryUID}
            />
          :
          <>
            <QueryToolbar
              ref={this.queryToolbarRef}
              history={this.props.history}
              user={this.props.user}
              dispatch={this.props.dispatch}
              searchFilter={this.props.searchFilter}
              updateProbands={probands => this.setState({ probands })}
              openReport={this.openSaveReportModal}
              reports={this.state.reports}
              queryProbands = {() => this.queryProbands()}
              loadReport={(report)=>this.loadReport(report)}
              openDeleteReportModal={(report)=> this.openDeleteReportModal(report)}
              />

            <br />

            <ErrorSummary errorMessages={this.state.errorMessages} />

            <ResultFilter
              ref={this.resultFilterRef}
              getSetFilterHashes={(setFilterHashes) => this.getSetFilterHashes(setFilterHashes)}
              diseaseFilterRef={this.diseaseFilterRef}
              geneTestingFilterRef={this.geneTestingFilterRef}
              referralFilterRef={this.referralFilterRef}
              moreFilterRef={this.moreFilterRef}
              onEditColumn={(columns, all_columns)=>{this.handleEditColumn(columns, all_columns)}}
              onRearrangeColumn={(columns, all_columns) =>{this.handleReorderColumns(columns, all_columns)}}
              downloadCSV={this.downloadCSV}
              changeDiseaseFilters={(disease_filters, includeUMLS, isActive) => this.changeDiseaseFilters(disease_filters, includeUMLS, isActive)}
              changeGeneFilters={(gene_filters, isActive)=>this.changeGeneFilters(gene_filters, isActive)}
              changeMoreFilters={(more_filters, isActive)=>this.changeMoreFilters(more_filters, isActive)}
              handleIsActiveChange={(filter_name, isActive) => this.handleIsActiveChange(filter_name, isActive)}
              changeReferralFilters={(referral_filters, isActive) => this.changeReferralFilters(referral_filters, isActive)}
              onCopy={this.copyText}
              onClearFilters={this.handleClearFilter}
              savePDF={this.onSavePDF}
              viewPatient={(id) => this.viewPatient(id)}
              openDeletePatientModal={(id) => this.openDeletePatientModal(id)}
              recordsCount={this.state.records_count}
              defaultColumns={this.state.allColumns}
              setShowAdvancedFilters={this.setShowAdvancedFilters}
              advanced_filters_results={this.state.advanced_filters_results}
              active_ordered_filters={this.state.active_ordered_filters}
              setActiveOrderedFilters={(active_ordered_filters) => this.setState({ active_ordered_filters })}
              runAdvancedQuery={() => this.runAdvancedQuery()}
              active_advanced_filter={this.state.active_advanced_filter}
            />

            <div style={{marginBottom: '2%'}}></div>

            <table id="example1" className="table table-custom ">
              <thead>
                <tr>

                  {this.state.columns.map(item => {
                    return <th key={createUUID()}>{item.label}</th>
                  })}

                  {results.length > 0 && (this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running') && 'matching_members' in results[0] && (
                    <>
                      <th>Proband ID</th>
                      <th>Relationship to Proband</th>
                    </>
                  )}

                  <th></th>

                </tr>
              </thead>
              <tbody>

                {results.map((result) => {
                  if ('matching_members' in result){
                    return(
                      result.matching_members.map(patient => {
                        return (
                          <React.Fragment key={createUUID()}>
                            <tr>
                              {this.state.columns.map((item) => {
                                if (item.value === 'dob') {
                                  return <td key={createUUID()}>{moment(patient[item.value]).format(this.getLocaleDateString())}</td>
                                } else if(item.value === 'modified_at') {
                                  return <td key={createUUID()}>{moment(patient.family_last_modified).format(this.getLocaleDateString())}</td>
                                } else if (item.value == 'diseases' && patient.diseases) {
                                  let stringForDisease = " "
                                  if (patient[item.value] !== undefined && patient[item.value] !== null) {
                                    for (let disease of patient[item.value]) {
                                      let age = disease.age_diagnosed_string ? disease.age_diagnosed_string : disease.age_diagnosed ? disease.age_diagnosed : '?'
                                      let disease_name = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? disease.disease_name : disease.name ? disease.name.disease_name : null
                                      if(disease_name){
                                        stringForDisease += disease_name + ' ' + age + ', '
                                      }else if(disease.umls_name){
                                        stringForDisease += disease.umls_name + ' ' + age + ', '
                                      }
                                    }
                                    stringForDisease = stringForDisease.slice(0, -2)
                                  }
                                  return <td key={createUUID()}>{stringForDisease}</td>
                                } else if (item.value === 'gene_summary') {
                                  var stringForGene = "";
                                  if (patient[item.value] !== undefined && patient[item.value] !== null) {
                                    for (let gene of patient[item.value]) {

                                      if (gene.result === "p") {
                                        gene.result = "Pathogenic"
                                      }
                                      else if (gene.result === "lp") {
                                        gene.result = "Likely Pathogenic"
                                      }
                                      else if (gene.result === "ln") {
                                        gene.result = "Likely Benign"
                                      }
                                      else if (gene.result === "u") {
                                        gene.result = "Unsure"
                                      }
                                      else if (gene.result === "vus") {
                                        gene.result = "VUS"
                                      }
                                      else if (gene.result === "n") {
                                        gene.result = "Negative"
                                      }else if(gene.result == "No Result"){
                                        gene.result = "No Result"
                                      }
                                      if(gene.name){
                                        stringForGene += gene.name.gene + " " + gene.result + ', ';
                                      }else if(gene.umls_name){
                                        stringForGene += gene.umls_name + " " + gene.result + ', ';
                                      }
                                    }
                                    stringForGene = stringForGene.slice(0, -2)
                                  }
                                  return <td key={createUUID()}>{stringForGene}</td>
                                } else if (item.value === 'referral_criteria'){
                                  let stringforReferralCriteria = ''
                                  if((this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running') && patient.referral_criteria){
                                    let proband_referral_criteria_string = patient.referral_criteria.map(criteria => criteria.condition_name);
                                    proband_referral_criteria_string = proband_referral_criteria_string.join();
                                    stringforReferralCriteria = this.getReferralCriteriaString(proband_referral_criteria_string);
                                  }
                                  else{
                                    stringforReferralCriteria = patient["referral_criteria_string"]
                                  }
                                  return <td key={createUUID()}>{stringforReferralCriteria}</td>
                                  //display clinician here
                                } else if (item.value === 'clinician') {
                                  let label = this.getCliniciansLabel(patient.clinicians)
                                  return (<OutsideAlerter key={createUUID()} action={() => this.setCurrentlyActivePatientForClinicianColumn('')} patientID={patient.id} setCurrentlyActivePatientForClinicianColumn={(id) => this.setCurrentlyActivePatientForClinicianColumn(id)}
                                                            setCurrentlyHoveredPatientForClinicianColumn={(id) => this.setCurrentlyHoveredPatientForClinicianColumn(id)} clinicianColumn={true}>
                                    {this.state.currently_active_patient_for_clinician_column == String(patient.id) ? <div className="form-group selectric-multiple">
                                      <div className="col-12">
                                        <Select
                                          value={patient.clinicians}
                                          name="clinician"
                                          onChange={(clinician_array) => this.changeClinician(patient, clinician_array)}
                                          className="react-select-container"
                                          classNamePrefix="react-select"
                                          isClearable={true}
                                          isMulti
                                          placeholder=""
                                          options={this.state.org_clinicians}
                                        />
                                      </div>
                                    </div>
                                      :
                                      <div style={{display: 'flex', cursor: 'pointer'}}>
                                        <div style={{flex: '1'}}>{label}</div>
                                        {this.state.currently_hovered_patient_for_clinician_column == String(patient.id) &&
                                        <div style={{alignSelf: 'flex-end'}}><a><i className="fa fa-edit"></i></a></div>}
                                      </div>}
                                  </OutsideAlerter>)
                                } else if (item.value === 'last_name' || item.value === 'first_name'){
                                  return <td key={createUUID()} className='col-1' style={{wordBreak:'break-word'}}>{patient[item.value]}</td>
                                } else if (item.value === 'sex_at_birth'){
                                  return <td key={createUUID()}>{patient['gender'] ? patient['gender'].toUpperCase() : ''}</td>
                                } else if (item.value === 'age'){
                                  return <td key={createUUID()}>{patient['age_string'] ? patient['age_string'] : patient[item.value] ? patient[item.value] : ''}</td>
                                } else {
                                  return <td key={createUUID()}>{patient[item.value]}</td>
                                }
                              })}
                              <td className="middle">
                                {result.proband.id}
                              </td>

                              <td className="middle">
                                {patient['relation_to_proband']}
                              </td>

                              <td className="middle">
                                <button id={`view-${patient.id}`} className="btn btn-light btn-xs table-btn-view margin-right-six" onClick={(e) => this.viewPatient(result.proband.id, "DOM", e, patient.id)}><i className="fa fa-eye"></i>&nbsp;View</button>
                                <button id={`delete-${patient.id}`} className="btn btn-light-outline table-btn-edit" type="button" onClick={() => this.openDeletePatientModal(patient.id)}><i className="fa fa-trash"></i>Delete</button>
                              </td>
                            </tr>
                          </React.Fragment>
                        )
                      }))
                  }
                  else{
                    let patient = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? result.proband : result;
                    return (
                      <React.Fragment key={createUUID()}>
                        <tr>
                          {this.state.columns.map((item) => {
                            if (item.value === 'dob') {
                              return <td key={createUUID()}>{moment(patient[item.value]).format(this.getLocaleDateString())}</td>
                            } else if(item.value === 'modified_at') {
                              return <td key={createUUID()}>{moment(patient.family_last_modified).format(this.getLocaleDateString())}</td>
                            } else if (item.value == 'diseases' && patient.diseases) {
                              let stringForDisease = " "
                              if (patient[item.value] !== undefined && patient[item.value] !== null) {
                                for (let disease of patient[item.value]) {
                                  let age = disease.age_diagnosed_string ? disease.age_diagnosed_string : disease.age_diagnosed ? disease.age_diagnosed : '?'
                                  let disease_name = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? disease.disease_name : disease.name ? disease.name.disease_name : null
                                  if(disease_name){
                                    stringForDisease += disease_name + ' ' + age + ', '
                                  }else if(disease.umls_name){
                                    stringForDisease += disease.umls_name + ' ' + age + ', '
                                  }
                                }
                                stringForDisease = stringForDisease.slice(0, -2)
                              }
                              return <td key={createUUID()}>{stringForDisease}</td>
                            } else if (item.value === 'gene_summary') {
                              var stringForGene = "";
                              if (patient[item.value] !== undefined && patient[item.value] !== null) {
                                for (let gene of patient[item.value]) {

                                  if (gene.result === "p") {
                                    gene.result = "Pathogenic"
                                  }
                                  else if (gene.result === "lp") {
                                    gene.result = "Likely Pathogenic"
                                  }
                                  else if (gene.result === "ln") {
                                    gene.result = "Likely Benign"
                                  }
                                  else if (gene.result === "u") {
                                    gene.result = "Unsure"
                                  }
                                  else if (gene.result === "vus") {
                                    gene.result = "VUS"
                                  }
                                  else if (gene.result === "n") {
                                    gene.result = "Negative"
                                  }else if(gene.result == "No Result"){
                                    gene.result = "No Result"
                                  }
                                  if(gene.name){
                                    stringForGene += gene.name.gene + " " + gene.result + ', ';
                                  }else if(gene.umls_name){
                                    stringForGene += gene.umls_name + " " + gene.result + ', ';
                                  }
                                }
                                stringForGene = stringForGene.slice(0, -2)
                              }
                              return <td key={createUUID()}>{stringForGene}</td>
                            } else if (item.value === 'referral_criteria'){
                              let stringforReferralCriteria = ''
                              if((this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running') && patient.referral_criteria){
                                let proband_referral_criteria_string = patient.referral_criteria.map(criteria => criteria.condition_name);
                                proband_referral_criteria_string = proband_referral_criteria_string.join();
                                stringforReferralCriteria = this.getReferralCriteriaString(proband_referral_criteria_string);
                              }
                              else{
                                stringforReferralCriteria = patient["referral_criteria_string"]
                              }
                              return <td key={createUUID()}>{stringforReferralCriteria}</td>
                              //display clinician here
                            } else if (item.value === 'clinician') {
                              let label = this.getCliniciansLabel(patient.clinicians)
                              return (<OutsideAlerter key={createUUID()} action={() => this.setCurrentlyActivePatientForClinicianColumn('')} patientID={patient.id} setCurrentlyActivePatientForClinicianColumn={(id) => this.setCurrentlyActivePatientForClinicianColumn(id)}
                                                        setCurrentlyHoveredPatientForClinicianColumn={(id) => this.setCurrentlyHoveredPatientForClinicianColumn(id)} clinicianColumn={true}>
                                {this.state.currently_active_patient_for_clinician_column == String(patient.id) ? <div className="form-group selectric-multiple">
                                  <div className="col-12">
                                    <Select
                                      value={patient.clinicians}
                                      name="clinician"
                                      onChange={(clinician_array) => this.changeClinician(patient, clinician_array)}
                                      className="react-select-container"
                                      classNamePrefix="react-select"
                                      isClearable={true}
                                      isMulti
                                      placeholder=""
                                      options={this.state.org_clinicians}
                                    />
                                  </div>
                                </div>
                                  :
                                  <div style={{display: 'flex', cursor: 'pointer'}}>
                                    <div style={{flex: '1'}}>{label}</div>
                                    {this.state.currently_hovered_patient_for_clinician_column == String(patient.id) &&
                                    <div style={{alignSelf: 'flex-end'}}><a><i className="fa fa-edit"></i></a></div>}
                                  </div>}
                              </OutsideAlerter>)
                            } else if (item.value === 'last_name' || item.value === 'first_name'){
                              return <td key={createUUID()} className='col-1' style={{wordBreak:'break-word'}}>{patient[item.value]}</td>
                            } else if (item.value === 'sex_at_birth'){
                              return <td key={createUUID()}>{patient['gender'] ? patient['gender'].toUpperCase() : ''}</td>
                            } else if (item.value === 'age'){
                              return <td key={createUUID()}>{patient['age_string'] ? patient['age_string'] : patient[item.value] ? patient[item.value] : ''}</td>
                            } else {
                              return <td key={createUUID()}>{patient[item.value]}</td>
                            }
                          })}

                          <td className="middle">
                            <button id={`view-${patient.id}`} className="btn btn-light btn-xs table-btn-view margin-right-six" onClick={(e) => this.viewPatient(patient.id, "DOM", e)}><i className="fa fa-eye"></i>&nbsp;View</button>
                            <button id={`delete-${patient.id}`} className="btn btn-light-outline table-btn-edit" type="button" onClick={() => this.openDeletePatientModal(patient.id)}><i className="fa fa-trash"></i>Delete</button>
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                  }
                })}

              </tbody>
            </table>

            {this.state.showDeletePatientModal && (
              <ModalDeletePatient
                patient={currentPatient}
                onClose={this.closeDeletePatientModal}
                onClickDelete={(payload) => this.onDeletePatient(payload)}
              />
            )}

            {this.state.showSaveReport && (
              <ModalSaveReport
                onClose={this.closeReportModal}
                onClickSave={(reportTitle)=>this.saveNewReport(reportTitle)}
              />
            )}

            {this.state.showOverwriteReport[0] && (
              <ModalOverwriteReport
                onClose={this.closeOverwriteReportModal}
                reportTitle={this.state.showOverwriteReport[1]}
                onClickSave={(reportTitle) => this.overWriteReport(reportTitle)}
              />
            )}

            {this.state.showDeleteReportModal[0] && (
              <ModalConfirmReportDelete
                title="Delete Report"
                message="Are you sure you would like to delete this report?"
                isOpen={this.state.showDeleteReportModal[0]}
                onCancel={() => this.setState({ showDeleteReportModal: [false, ''] })}
                onOk={() => this.deleteReport()}
                loading={this.state.loading}
                errorMessages={this.state.errorMessages}
              />
            )}

            <ActivityIndicator loading={this.state.loading} modal={true} />
          </>
        }


      </React.Fragment>
    )
  }
}

const redux_state = state => ({
  user: state.session.user,
  searchFilter: state.search.searchFilter,
  static_list: state.static_list,
  org_clinicians: state.session.user.org_clinicians
});

const redux_actions = dispatch => ({
  dispatch: action => dispatch(action)
});

export default connect(
  redux_state,
  redux_actions,
  null,
  { forwardRef: true }
)(ResultList);
